import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ActivateUserAccountService } from "../../services/auth.service";
import { StatusCodes } from "http-status-codes";
import { toast } from "react-toastify";
const ActiveAccount = () => {
  const { id, token } = useParams();
  const [activeAccStatus, setActiveAccStatus] = useState<boolean>(false);
  const ActiveUserAccount = async () => {
    const response = await ActivateUserAccountService(id, token);
    if (response.status && response.status_code === StatusCodes.OK) {
      toast.success(response.message);
      setActiveAccStatus(true);
    } else toast.error(response.message);
  };
  useEffect(() => {
    if (id && token) ActiveUserAccount();
  }, [id, token]);
  return (
    <div className="flex justify-center items-center flex-col">
      {activeAccStatus && (
        <>
          <p>Thank you. Your account is now active.</p>
          <a className="underline text-blue-500 cursor-pointer" href={"/"}>
            Login here
          </a>
        </>
      )}
    </div>
  );
};

export default ActiveAccount;
